/* eslint-disable */
// This is auto generated code, do not edit directly
// @ts-ignore
import * as Types from '../../../../core/graphql/generated/types';

import { gql } from '@apollo/client';
import { BadRequestFragmentDoc } from '../../../../core/fragments/core.hook';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetDcrSetupQueryVariables = Types.Exact<{
	countryId: Types.Scalars['ID']['input'];
}>;

export type GetDcrSetupQuery = {
	__typename?: 'Query';
	dcrUnavailableFields:
		| { __typename?: 'BadRequest'; message: string; errors: Array<string> }
		| { __typename?: 'Forbidden' }
		| { __typename?: 'UnavailableFields'; results: Array<string> };
};

export const GetDcrSetupDocument = gql`
	query GetDCRSetup($countryId: ID!) {
		dcrUnavailableFields(countryId: $countryId) {
			... on UnavailableFields {
				results
			}
			...BadRequest
		}
	}
	${BadRequestFragmentDoc}
`;

/**
 * __useGetDcrSetupQuery__
 *
 * To run a query within a React component, call `useGetDcrSetupQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetDcrSetupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetDcrSetupQuery({
 *   variables: {
 *      countryId: // value for 'countryId'
 *   },
 * });
 */
export function useGetDcrSetupQuery(
	baseOptions: Apollo.QueryHookOptions<
		GetDcrSetupQuery,
		GetDcrSetupQueryVariables
	> &
		(
			| { variables: GetDcrSetupQueryVariables; skip?: boolean }
			| { skip: boolean }
		)
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetDcrSetupQuery, GetDcrSetupQueryVariables>(
		GetDcrSetupDocument,
		options
	);
}
export function useGetDcrSetupLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetDcrSetupQuery,
		GetDcrSetupQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetDcrSetupQuery, GetDcrSetupQueryVariables>(
		GetDcrSetupDocument,
		options
	);
}
export function useGetDcrSetupSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<
				GetDcrSetupQuery,
				GetDcrSetupQueryVariables
		  >
) {
	const options =
		baseOptions === Apollo.skipToken
			? baseOptions
			: { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetDcrSetupQuery, GetDcrSetupQueryVariables>(
		GetDcrSetupDocument,
		options
	);
}
export type GetDcrSetupQueryHookResult = ReturnType<typeof useGetDcrSetupQuery>;
export type GetDcrSetupLazyQueryHookResult = ReturnType<
	typeof useGetDcrSetupLazyQuery
>;
export type GetDcrSetupSuspenseQueryHookResult = ReturnType<
	typeof useGetDcrSetupSuspenseQuery
>;
export type GetDcrSetupQueryResult = Apollo.QueryResult<
	GetDcrSetupQuery,
	GetDcrSetupQueryVariables
>;
